// Externe Bibliotheken
import { useEffect, useRef } from 'react';

/**
 * @param children
 * @param exceptionRef
 * @param onClick
 * @param className
 * @returns {JSX.Element}
 * @constructor
 */
export default function ClickOutside({ children, exceptionRef, onClick, className }) {
    const wrapperRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            let clickedInside;
            if (exceptionRef) {
                clickedInside =
                    (wrapperRef && wrapperRef.current.contains(event.target)) ||
                    exceptionRef.current === event.target ||
                    exceptionRef.current.contains(event.target);
            } else {
                clickedInside = wrapperRef && wrapperRef.current.contains(event.target);
            }

            if (clickedInside) {
                return true;
            } else {
                onClick();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [exceptionRef, onClick]);

    return (
        <div ref={wrapperRef} className={`${className || ''}`}>
            {children}
        </div>
    );
}
